var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3654_19550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4413 21.651C28.6352 21.651 31.2243 19.0429 31.2243 15.8255C31.2243 12.6082 28.6352 10 25.4413 10C22.2474 10 19.6582 12.6082 19.6582 15.8255C19.6582 19.0429 22.2474 21.651 25.4413 21.651Z",
    fill: "#78E6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8335 52.8572C49.6055 52.8572 51.8526 50.5936 51.8526 47.8013C51.8526 45.009 49.6055 42.7454 46.8335 42.7454C44.0616 42.7454 41.8145 45.009 41.8145 47.8013C41.8145 50.5936 44.0616 52.8572 46.8335 52.8572Z",
    fill: "#78E6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6541 18.6848C58.5021 18.6848 60.0002 17.1757 60.0002 15.3142C60.0002 13.4527 58.5021 11.9436 56.6541 11.9436C54.8062 11.9436 53.3081 13.4527 53.3081 15.3142C53.3081 17.1757 54.8062 18.6848 56.6541 18.6848Z",
    fill: "#78E6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3542 22.5779C47.0621 19.5556 42.7736 18.9714 39.7678 21.2802C37.5426 22.9936 36.6559 25.8081 37.275 28.381C36.0035 33.8189 31.1573 37.8692 25.3687 37.8692C19.5912 37.8692 14.7506 33.8357 13.4679 28.409C13.9475 26.4541 13.5795 24.3025 12.2689 22.5779C9.97689 19.5556 5.68839 18.9714 2.68253 21.2802C-0.312172 23.5947 -0.886575 27.9203 1.40546 30.9426C3.07848 33.1504 5.82223 34.0492 8.34848 33.4762L10.5457 34.8525C12.6816 36.1951 14.4438 38.0658 15.6652 40.2848L18.4145 45.307C18.4758 45.4193 18.5204 45.5429 18.5427 45.6665C19.0279 47.9978 20.7177 50.1662 23.8741 51.1606C24.2031 51.2617 24.5489 51.3066 24.8891 51.2898C28.8764 51.0538 31.2688 48.5765 31.8934 45.7339C31.9269 45.5822 31.9827 45.4362 32.0663 45.307L35.0833 40.532C36.6894 37.9872 38.8532 35.8468 41.4073 34.2739L42.6509 33.5099C44.4913 33.8638 46.471 33.4593 48.0771 32.2234C51.0774 29.9146 51.6573 25.5946 49.3653 22.5667L49.3542 22.5779Z",
    fill: "url(#paint0_linear_3654_19550)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3654_19550",
    x1: 13.3173,
    y1: 38.004,
    x2: 38.2201,
    y2: 15.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73DBE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3654_19550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 42.8571,
    fill: "white",
    transform: "translate(0 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ccde2172efa5ad72ff08e6680b794e51.svg";
export { ForwardRef as ReactComponent };